import * as i1 from '@angular/common';
import { isPlatformBrowser, CommonModule, DOCUMENT } from '@angular/common';
import * as i0 from '@angular/core';
import { Directive, ElementRef, Inject, PLATFORM_ID, Input, HostBinding, NgModule, RendererFactory2, Injectable, InjectionToken } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import dayjs from 'dayjs';
import { stripHtml } from 'string-strip-html';
import * as i1$1 from '@wizbii/angular-utilities';
import { WINDOW } from '@wizbii/angular-utilities';
import { loadScript } from '@wizbii/tracking';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/platform-browser';
class HeadDescriptionDirective {
    constructor(el, metaService, platformId) {
        this.el = el;
        this.metaService = metaService;
        this.platformId = platformId;
        this.onlyDescription = false;
        this.baseMetas = [
            {
                name: 'twitter:description',
            },
            {
                property: 'og:description',
            },
            {
                itemprop: 'description',
            },
        ];
        this.display = 'none';
    }
    ngOnInit() {
        if (isPlatformBrowser(this.platformId)) {
            this.observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    this.init(mutation.target.textContent);
                });
            });
            this.observer.observe(this.el.nativeElement, {
                characterData: false,
                attributes: false,
                childList: true,
                subtree: false,
            });
        }
    }
    ngAfterViewInit() {
        this.init(this.el.nativeElement.textContent);
    }
    ngOnDestroy() {
        if (isPlatformBrowser(this.platformId)) {
            this.observer.disconnect();
        }
    }
    init(textContent) {
        const description = textContent.trim();
        if (this.metaService.getTag('name="description"')) {
            this.metaService.updateTag({
                name: 'description',
                content: description,
            });
        }
        else {
            this.metaService.addTag({
                name: 'description',
                content: description,
            });
        }
        if (this.onlyDescription) {
            return;
        }
        if (this.metaService.getTag('property="og:description"')) {
            this.baseMetas.forEach((meta) => {
                this.metaService.updateTag(Object.assign(Object.assign({}, meta), { content: description }));
            });
        }
        else {
            this.metaService.addTags(this.baseMetas.map((meta) => (Object.assign(Object.assign({}, meta), { content: description }))));
        }
    }
}
HeadDescriptionDirective.ɵfac = function HeadDescriptionDirective_Factory(t) { return new (t || HeadDescriptionDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.Meta), ɵngcc0.ɵɵdirectiveInject(PLATFORM_ID)); };
HeadDescriptionDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: HeadDescriptionDirective, selectors: [["span", "wizHeadDescription", ""]], hostVars: 2, hostBindings: function HeadDescriptionDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("display", ctx.display);
    } }, inputs: { onlyDescription: "onlyDescription" } });
HeadDescriptionDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Meta },
    { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] }
];
HeadDescriptionDirective.propDecorators = {
    onlyDescription: [{ type: Input }],
    display: [{ type: HostBinding, args: ['style.display',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HeadDescriptionDirective, [{
        type: Directive,
        args: [{
                selector: 'span[wizHeadDescription]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc1.Meta }, { type: undefined, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }]; }, { onlyDescription: [{
            type: Input
        }], display: [{
            type: HostBinding,
            args: ['style.display']
        }] }); })();
class HeadDescriptionModule {
}
HeadDescriptionModule.ɵfac = function HeadDescriptionModule_Factory(t) { return new (t || HeadDescriptionModule)(); };
HeadDescriptionModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HeadDescriptionModule });
HeadDescriptionModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HeadDescriptionModule, [{
        type: NgModule,
        args: [{
                declarations: [HeadDescriptionDirective],
                imports: [CommonModule],
                exports: [HeadDescriptionDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HeadDescriptionModule, { declarations: function () { return [HeadDescriptionDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [HeadDescriptionDirective]; } }); })();

class HeadTitleDirective {
    constructor(el, titleService, metaService, platformId) {
        this.el = el;
        this.titleService = titleService;
        this.metaService = metaService;
        this.platformId = platformId;
        this.display = 'none';
        this.baseMetas = [
            {
                name: 'twitter:title',
            },
            {
                property: 'og:title',
            },
        ];
        this.metaElements = [];
    }
    ngOnInit() {
        if (isPlatformBrowser(this.platformId)) {
            this.observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    this.clean();
                    this.init(mutation.target.textContent);
                });
            });
            this.observer.observe(this.el.nativeElement, {
                characterData: false,
                attributes: false,
                childList: true,
                subtree: false,
            });
        }
    }
    ngAfterViewInit() {
        this.init(this.el.nativeElement.textContent);
    }
    ngOnDestroy() {
        this.clean();
        if (isPlatformBrowser(this.platformId)) {
            this.observer.disconnect();
        }
    }
    clean() {
        this.metaElements.forEach((meta) => {
            this.metaService.removeTagElement(meta);
        });
    }
    init(textContent) {
        const title = textContent.trim();
        if (this.metaService.getTag('property="og:title"')) {
            this.baseMetas.forEach((meta) => {
                this.metaService.updateTag(Object.assign(Object.assign({}, meta), { content: title }));
            });
        }
        else {
            this.metaService.addTags(this.baseMetas.map((meta) => (Object.assign(Object.assign({}, meta), { content: title }))));
        }
        this.titleService.setTitle(title);
    }
}
HeadTitleDirective.ɵfac = function HeadTitleDirective_Factory(t) { return new (t || HeadTitleDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.Title), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.Meta), ɵngcc0.ɵɵdirectiveInject(PLATFORM_ID)); };
HeadTitleDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: HeadTitleDirective, selectors: [["span", "wizHeadTitle", ""]], hostVars: 2, hostBindings: function HeadTitleDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("display", ctx.display);
    } } });
HeadTitleDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Title },
    { type: Meta },
    { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] }
];
HeadTitleDirective.propDecorators = {
    display: [{ type: HostBinding, args: ['style.display',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HeadTitleDirective, [{
        type: Directive,
        args: [{
                selector: 'span[wizHeadTitle]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc1.Title }, { type: ɵngcc1.Meta }, { type: undefined, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }]; }, { display: [{
            type: HostBinding,
            args: ['style.display']
        }] }); })();
class HeadTitleModule {
}
HeadTitleModule.ɵfac = function HeadTitleModule_Factory(t) { return new (t || HeadTitleModule)(); };
HeadTitleModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HeadTitleModule });
HeadTitleModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HeadTitleModule, [{
        type: NgModule,
        args: [{
                declarations: [HeadTitleDirective],
                imports: [CommonModule],
                exports: [HeadTitleDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HeadTitleModule, { declarations: function () { return [HeadTitleDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [HeadTitleDirective]; } }); })();

var EmploymentTypeEnum;
(function (EmploymentTypeEnum) {
    EmploymentTypeEnum["FULL_TIME"] = "FULL_TIME";
    EmploymentTypeEnum["PART_TIME"] = "PART_TIME";
    EmploymentTypeEnum["CONTRACTOR"] = "CONTRACTOR";
    EmploymentTypeEnum["TEMPORARY"] = "TEMPORARY";
    EmploymentTypeEnum["INTERN"] = "INTERN";
    EmploymentTypeEnum["VOLUNTEE"] = "VOLUNTEE";
    EmploymentTypeEnum["PER_DIEM"] = "PER_DIEM";
    EmploymentTypeEnum["OTHER"] = "OTHER";
    EmploymentTypeEnum["SEASONAL"] = "SEASONAL";
})(EmploymentTypeEnum || (EmploymentTypeEnum = {}));

var EventAttendanceModeEnum;
(function (EventAttendanceModeEnum) {
    EventAttendanceModeEnum["OnlineEventAttendanceMode"] = "https://schema.org/OnlineEventAttendanceMode";
    EventAttendanceModeEnum["OfflineEventAttendanceMode"] = "https://schema.org/OfflineEventAttendanceMode";
    EventAttendanceModeEnum["MixedEventAttendanceMode"] = "https://schema.org/MixedEventAttendanceMode";
})(EventAttendanceModeEnum || (EventAttendanceModeEnum = {}));

var EventStatusEnum;
(function (EventStatusEnum) {
    EventStatusEnum["EventCancelled"] = "https://schema.org/EventCancelled";
    EventStatusEnum["EventMovedOnline"] = "https://schema.org/EventMovedOnline";
    EventStatusEnum["EventPostponed"] = "https://schema.org/EventPostponed";
    EventStatusEnum["EventRescheduled"] = "https://schema.org/EventRescheduled";
    EventStatusEnum["EventScheduled"] = "https://schema.org/EventScheduled";
})(EventStatusEnum || (EventStatusEnum = {}));

var OfferAvailabilityEnum;
(function (OfferAvailabilityEnum) {
    OfferAvailabilityEnum["BackOrder"] = "https://schema.org/BackOrder";
    OfferAvailabilityEnum["Discontinued"] = "https://schema.org/Discontinued";
    OfferAvailabilityEnum["InStock"] = "https://schema.org/InStock";
    OfferAvailabilityEnum["InStoreOnly"] = "https://schema.org/InStoreOnly";
    OfferAvailabilityEnum["LimitedAvailability"] = "https://schema.org/LimitedAvailability";
    OfferAvailabilityEnum["OnlineOnly"] = "https://schema.org/OnlineOnly";
    OfferAvailabilityEnum["OutOfStock"] = "https://schema.org/OutOfStock";
    OfferAvailabilityEnum["PreOrder"] = "https://schema.org/PreOrder";
    OfferAvailabilityEnum["PreSale"] = "https://schema.org/PreSale";
    OfferAvailabilityEnum["SoldOut"] = "https://schema.org/SoldOut";
})(OfferAvailabilityEnum || (OfferAvailabilityEnum = {}));

class MicroDataService {
    constructor(document, rendererFactory) {
        this.document = document;
        this.rendererFactory = rendererFactory;
        this.scriptType = 'application/ld+json';
        this.renderer = this.rendererFactory.createRenderer(null, null);
    }
    removeStructuredData() {
        const headerElement = this.document.head;
        const elements = [];
        ['structured-data'].forEach((c) => {
            elements.push(...Array.from(headerElement.getElementsByClassName(c)));
        });
        elements.forEach((el) => this.renderer.removeChild(headerElement, el));
    }
    insertSchema(schema, className = 'structured-data') {
        let script;
        let shouldAppend = false;
        const headerElement = this.document.head;
        if (headerElement.getElementsByClassName(className).length) {
            script = headerElement.getElementsByClassName(className)[0];
        }
        else {
            script = this.renderer.createElement('script');
            shouldAppend = true;
        }
        this.renderer.setAttribute(script, 'class', className);
        script.type = this.scriptType;
        script.text = JSON.stringify(schema);
        if (shouldAppend) {
            this.renderer.appendChild(headerElement, script);
        }
    }
}
MicroDataService.ctorParameters = () => [
    { type: Document, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: RendererFactory2 }
];

class JobMicroDataService extends MicroDataService {
    generateSchemaJsonLD(job) {
        var _a, _b, _c, _d;
        return Object.assign(Object.assign({ '@context': 'https://schema.org', '@type': 'JobPosting', datePosted: dayjs(job.datePosted).toISOString(), description: job.description, title: job.title, validThrough: dayjs(job.validThrough).toISOString(), hiringOrganization: Object.assign({ '@type': 'Organization', name: job.hiringOrganization.name, sameAs: job.hiringOrganization.sameAs }, (((_a = job.hiringOrganization) === null || _a === void 0 ? void 0 : _a.logo) && { logo: job.hiringOrganization.logo })), jobLocation: Object.assign(Object.assign({ '@type': 'Place' }, (((_b = job.jobLocation) === null || _b === void 0 ? void 0 : _b.address) && {
                address: Object.assign(Object.assign({ '@type': 'PostalAddress', addressCountry: job.jobLocation.address.addressCountry }, (((_c = job.jobLocation) === null || _c === void 0 ? void 0 : _c.address.addressLocality) && {
                    addressLocality: job.jobLocation.address.addressLocality,
                })), { postalCode: job.jobLocation.address.postalCode, addressRegion: job.jobLocation.address.addressRegion }),
            })), (((_d = job.jobLocation) === null || _d === void 0 ? void 0 : _d.geo) && {
                geo: {
                    '@type': 'GeoCoordinates',
                    latitude: job.jobLocation.geo.latitude,
                    longitude: job.jobLocation.geo.longitude,
                },
            })) }, (job.employmentType && { employmentType: job.employmentType })), (job.baseSalary && {
            baseSalary: {
                '@type': 'MonetaryAmount',
                currency: job.baseSalary.currency,
                value: {
                    '@type': 'QuantitativeValue',
                    value: job.baseSalary.value.value,
                    unitText: job.baseSalary.value.unitText,
                },
            },
        }));
    }
}
JobMicroDataService.ɵfac = /*@__PURE__*/ function () { let ɵJobMicroDataService_BaseFactory; return function JobMicroDataService_Factory(t) { return (ɵJobMicroDataService_BaseFactory || (ɵJobMicroDataService_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(JobMicroDataService)))(t || JobMicroDataService); }; }();
JobMicroDataService.ɵprov = i0.ɵɵdefineInjectable({ factory: function JobMicroDataService_Factory() { return new JobMicroDataService(i0.ɵɵinject(i1.DOCUMENT), i0.ɵɵinject(i0.RendererFactory2)); }, token: JobMicroDataService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(JobMicroDataService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();

class EventMicroDataService extends MicroDataService {
    generateSchemaJsonLD(event) {
        var _a, _b;
        return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ '@context': 'https://schema.org', '@type': 'Event', name: event.name }, (event.startDate && { startDate: dayjs(event.startDate).toISOString() })), (event.endDate && { endDate: dayjs(event.endDate).toISOString() })), (event.eventAttendanceMode && { eventAttendanceMode: event.eventAttendanceMode })), (event.eventStatus && { eventStatus: event.eventStatus })), (event.image && { image: event.image })), (event.organizer && {
            organizer: Object.assign(Object.assign({ '@type': 'Organization', name: event.organizer.name, url: event.organizer.url }, (((_a = event.organizer) === null || _a === void 0 ? void 0 : _a.logo) && { logo: event.organizer.logo })), (((_b = event.organizer) === null || _b === void 0 ? void 0 : _b.sameAs) && { sameAs: event.organizer.sameAs })),
        })), (event.description && {
            description: stripHtml(event.description).result,
        })), (event.offers && {
            offers: {
                '@type': 'Offer',
                url: event.offers.url,
                price: event.offers.price,
                priceCurrency: event.offers.priceCurrency,
                availability: event.offers.availability,
            },
        })), { location: [
                ...(event.virtualLocation || []).map((location) => ({
                    '@type': 'VirtualLocation',
                    url: location.url,
                })),
                ...event.location.map((location) => (Object.assign(Object.assign({ '@type': 'Place', name: location.name }, (location.geo && {
                    geo: {
                        '@type': 'GeoCoordinates',
                        latitude: location.geo.latitude,
                        longitude: location.geo.longitude,
                    },
                })), (location.address && {
                    address: Object.assign(Object.assign(Object.assign(Object.assign({ '@type': 'PostalAddress' }, (location.address.addressCountry && { addressCountry: location.address.addressCountry })), (location.address.addressLocality && {
                        addressLocality: location.address.addressLocality,
                    })), (location.address.postalCode && { postalCode: location.address.postalCode })), (location.address.addressRegion && { addressRegion: location.address.addressRegion })),
                })))),
            ] });
    }
}
EventMicroDataService.ɵfac = /*@__PURE__*/ function () { let ɵEventMicroDataService_BaseFactory; return function EventMicroDataService_Factory(t) { return (ɵEventMicroDataService_BaseFactory || (ɵEventMicroDataService_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(EventMicroDataService)))(t || EventMicroDataService); }; }();
EventMicroDataService.ɵprov = i0.ɵɵdefineInjectable({ factory: function EventMicroDataService_Factory() { return new EventMicroDataService(i0.ɵɵinject(i1.DOCUMENT), i0.ɵɵinject(i0.RendererFactory2)); }, token: EventMicroDataService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EventMicroDataService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();

class BlogPostingMicroDataService extends MicroDataService {
    // eslint-disable-next-line sonarjs/cognitive-complexity
    generateSchemaJsonLD(blogPosting) {
        return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ '@context': 'https://schema.org', '@type': 'BlogPosting' }, (blogPosting.headline && { headline: blogPosting.headline })), (blogPosting.alternativeHeadline && { alternativeHeadline: blogPosting.alternativeHeadline })), (blogPosting.image && { image: blogPosting.image })), (blogPosting.award && { award: blogPosting.award })), (blogPosting.editor && { editor: blogPosting.editor })), (blogPosting.genre && { genre: blogPosting.genre })), (blogPosting.keywords && { keywords: blogPosting.keywords })), (blogPosting.wordCount && { wordCount: blogPosting.wordCount })), (blogPosting.publisher && { publisher: blogPosting.publisher })), (blogPosting.url && { url: blogPosting.url })), (blogPosting.datePublished && { datePublished: dayjs(blogPosting.datePublished).toISOString() })), (blogPosting.dateCreated && { dateCreated: dayjs(blogPosting.dateCreated).toISOString() })), (blogPosting.dateModified && { dateModified: dayjs(blogPosting.dateModified).toISOString() })), (blogPosting.description && { description: blogPosting.description })), (blogPosting.articleBody && { articleBody: blogPosting.articleBody })), { author: Object.assign({ '@type': 'Person' }, (blogPosting.author.name && { name: blogPosting.author.name })) });
    }
}
BlogPostingMicroDataService.ɵfac = /*@__PURE__*/ function () { let ɵBlogPostingMicroDataService_BaseFactory; return function BlogPostingMicroDataService_Factory(t) { return (ɵBlogPostingMicroDataService_BaseFactory || (ɵBlogPostingMicroDataService_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(BlogPostingMicroDataService)))(t || BlogPostingMicroDataService); }; }();
BlogPostingMicroDataService.ɵprov = i0.ɵɵdefineInjectable({ factory: function BlogPostingMicroDataService_Factory() { return new BlogPostingMicroDataService(i0.ɵɵinject(i1.DOCUMENT), i0.ɵɵinject(i0.RendererFactory2)); }, token: BlogPostingMicroDataService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BlogPostingMicroDataService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();

class FaqMicroDataService extends MicroDataService {
    // eslint-disable-next-line sonarjs/cognitive-complexity
    generateSchemaJsonLD(faqItems) {
        const faqSchema = [];
        faqItems.forEach(faq => {
            faqSchema.push({
                '@type': 'Question',
                'name': faq.name,
                'acceptedAnswer': {
                    '@type': 'Answer',
                    'text': faq.text
                }
            });
        });
        return {
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            "mainEntity": faqSchema
        };
    }
}
FaqMicroDataService.ɵfac = /*@__PURE__*/ function () { let ɵFaqMicroDataService_BaseFactory; return function FaqMicroDataService_Factory(t) { return (ɵFaqMicroDataService_BaseFactory || (ɵFaqMicroDataService_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(FaqMicroDataService)))(t || FaqMicroDataService); }; }();
FaqMicroDataService.ɵprov = i0.ɵɵdefineInjectable({ factory: function FaqMicroDataService_Factory() { return new FaqMicroDataService(i0.ɵɵinject(i1.DOCUMENT), i0.ɵɵinject(i0.RendererFactory2)); }, token: FaqMicroDataService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FaqMicroDataService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();

const TIME_ONE_API_CONFIG = new InjectionToken('TIME_ONE_API_CONFIG');

class TimeOneService {
    constructor(window, document, timeOneConfig) {
        this.window = window;
        this.document = document;
        this.timeOneConfig = timeOneConfig;
        this.alreadyInitGlobal = false;
        this.alreadyInitSales = false;
    }
    initGlobals() {
        if (this.alreadyInitGlobal) {
            return;
        }
        this.window.__dot = [
            {
                categoryID: '',
                productID: '',
                cartProductsID: '',
                cartAmount: '',
                orderID: '',
                orderAmount: '',
                hashClientID: '',
            },
        ];
        loadScript(`https://u.logbor.com/p/?i=${this.timeOneConfig.timeOneId}&n=__dot`);
        this.alreadyInitGlobal = true;
    }
    initSales(uniqId, dutyFreePrice, additionalData = '') {
        if (this.alreadyInitSales) {
            return;
        }
        this.window.tip = [];
        this.window.tip.push([
            '_setSale',
            this.timeOneConfig.tipFirstId,
            this.timeOneConfig.tipSecondId,
            this.timeOneConfig.apiKey,
            uniqId,
            dutyFreePrice.toString(10),
            additionalData,
        ]);
        function insertScript() {
            const e = document.createElement('script');
            e.type = 'text/javascript';
            e.async = true;
            e.src = 'https://tracking.publicidees.com/p/tip/';
            const t = document.getElementsByTagName('script')[0];
            t.parentNode.insertBefore(e, t);
        }
        if (this.document.readyState === 'complete') {
            insertScript();
        }
        else {
            if (this.window.addEventListener) {
                this.window.addEventListener('load', insertScript, false);
            }
            else if (this.window.attachEvent) {
                this.window.attachEvent('onload', insertScript);
            }
        }
        this.alreadyInitSales = true;
    }
    addDot(dot) {
        this.window.__dot.push(dot);
    }
}
TimeOneService.ɵfac = function TimeOneService_Factory(t) { return new (t || TimeOneService)(ɵngcc0.ɵɵinject(WINDOW), ɵngcc0.ɵɵinject(DOCUMENT), ɵngcc0.ɵɵinject(TIME_ONE_API_CONFIG)); };
TimeOneService.ɵprov = i0.ɵɵdefineInjectable({ factory: function TimeOneService_Factory() { return new TimeOneService(i0.ɵɵinject(i1$1.WINDOW), i0.ɵɵinject(i1.DOCUMENT), i0.ɵɵinject(TIME_ONE_API_CONFIG)); }, token: TimeOneService, providedIn: "root" });
TimeOneService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [WINDOW,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [TIME_ONE_API_CONFIG,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TimeOneService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [WINDOW]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [TIME_ONE_API_CONFIG]
            }] }]; }, null); })();

/*
 * Public API Surface of seo-lib
 */

/**
 * Generated bundle index. Do not edit.
 */

export { BlogPostingMicroDataService, EmploymentTypeEnum, EventAttendanceModeEnum, EventMicroDataService, EventStatusEnum, FaqMicroDataService, HeadDescriptionDirective, HeadDescriptionModule, HeadTitleDirective, HeadTitleModule, JobMicroDataService, MicroDataService, OfferAvailabilityEnum, TIME_ONE_API_CONFIG, TimeOneService };

